<div *ngIf="vm" class="redeem-card">
  <h2 class="redeem-title">{{ vm.title }}</h2>
  <div class="redeem-card-content">
    <h3 class="redeem-card-title">{{ vm.subtitle }}</h3>
    <p class="redeem-card-subtitle">{{ vm.instructions }}</p>
    <osn-shared-email-collector
      [inputPlaceholder]="'Redeem_Email_Input_txt' | translate"
      [buttonText]="vm.buttonText"
      [passwordPlaceholder]="passwordPlaceholderKey | translate"
      [hideMobileProviderButton]="true"
      [userEmail]="vm.defaultEmail || vm.userEmail"
      [showTickMark]="showTickMark$ | async"
      (submitted)="onSubmit()"
      (loginError)="onLoginError()"
    >
      <osn-shared-redeem-input
        *ngIf="vm.type === 'GenericRedeem' || (vm.type === 'PartnerRedeem' && !isBinInputShown)"
        class="redeem-input"
        osnSharedEmailCollectorAdditionalControl
        #additionalInput
        [additionalInputKey]="'voucher'"
        [validatorRegexp]="voucherRegexp"
        [formControl]="voucherFormControl"
        [readOnly]="!!vm.defaultPromoCode"
        type="text"
        [placeholder]="'Redeem_Promo_Input_txt' | translate"
        [fallbackError]="'Redeem_Promo_Error_txt' | translate"
        [gwError]="promoError"
        [readOnly]="!!vm.defaultVoucherCode"
      ></osn-shared-redeem-input>
      <osn-shared-redeem-input
        *ngIf="vm.type === 'PartnerRedeem' && isBinInputShown"
        osnSharedEmailCollectorAdditionalControl
        #additionalInput
        [additionalInputKey]="'bin'"
        [formControl]="binFormControl"
        [validatorRegexp]="binRegexp"
        type="number"
        [fallbackError]="'Redeem_Bin_Error_txt' | translate"
        [suffixIcon]="validIcon"
        [validIcon]="validIcon"
        [placeholder]="'Redeem_Bin_Input_Placeholder_txt' | translate"
        [tooltip]="'Redeem_Bin_Tooltip_txt' | translate"
        [gwError]="binError"
        [readOnly]="!!vm.defaultVoucherCode"
        [increasedIconSize]="true"
        (input)="onBinInput($event)"
        class="redeem-input"
      ></osn-shared-redeem-input>
    </osn-shared-email-collector>
  </div>
</div>
